import type { DayCloseLoadResult } from "@sobidogam/storage";

export type DayCloseRecovery = Extract<
	DayCloseLoadResult,
	{ status: "recovery" }
>;

/** Screens which consume stamps must never receive an invented empty stamp list. */
export function dayCloseRecoveryBlocksPath(path: string): boolean {
	return ![
		"/app/records",
		"/app/household",
		"/app/settings",
		"/app/help",
		"/app/entry",
		"/app/capture",
		"/app/confirm",
		"/app/onboarding",
		"/app/plus",
	].includes(path);
}

export function DayCloseRecoveryNotice({
	recovery,
	onDownload,
	onNavigate,
}: {
	recovery: DayCloseRecovery;
	onDownload: (raw: string) => void;
	onNavigate: (path: string) => void;
}) {
	return (
		<section className="notice" role="alert">
			<h2>마감 기록을 확인해야 해요</h2>
			<p>
				소비 기록과 집 안 물건은 열 수 있어요. 마감을 확인하기 전까지 오늘
				화면·날 도감·정리는 잠시 쉬어요. 마감한 날 수는 아직 알 수 없어요.
			</p>
			<p>
				{recovery.reason === "read_error"
					? "기기 저장소에서 마감을 읽지 못했어요. 브라우저 저장 공간을 확인한 뒤 다시 열어 주세요."
					: "마감 원문은 그대로 두었어요. 원문을 먼저 내려받고 설정에서 정상 백업 파일을 복원할 수 있어요. 복원 전 원문을 이 기기에 따로 보관해요."}
			</p>
			<div className="recovery-actions">
				{recovery.raw !== null ? (
					<button
						type="button"
						className="quiet-button"
						onClick={() => onDownload(recovery.raw ?? "")}
					>
						마감 원문 받기
					</button>
				) : null}
				<button
					type="button"
					className="quiet-button"
					onClick={() => onNavigate("/app/records")}
				>
					소비 내역 열기
				</button>
				<button
					type="button"
					className="quiet-button"
					onClick={() => onNavigate("/app/household")}
				>
					집 안 물건 열기
				</button>
				<button
					type="button"
					className="button"
					onClick={() => onNavigate("/app/settings")}
				>
					설정에서 백업 복원
				</button>
			</div>
		</section>
	);
}
